import { useTheme } from "@emotion/react";
import React, { useMemo } from "react";
import { MdBlock, MdCheckCircleOutline, MdOutlineInsertDriveFile } from "react-icons/md";

import { ticketStatuses, TicketStatus } from "@megaron/support-contracts";

import { SupportSelect, SupportSelectOption } from "./SupportSelect";

type Props = {
  value: TicketStatus;
  isDisabled?: boolean;
  onChange: (status: TicketStatus) => void;
};

const statusLabels: Record<TicketStatus, string> = {
  open: "Otwarty",
  resolved: "Zrealizowany",
  closed: "Zamknięty",
};

const statusColor = (
  status: TicketStatus,
  colors: { primary: string; success: string; danger: string },
) =>
  status === "resolved" ? colors.success : status === "closed" ? colors.danger : colors.primary;

const statusIcon = (status: TicketStatus) =>
  status === "resolved" ? (
    <MdCheckCircleOutline size={18} />
  ) : status === "closed" ? (
    <MdBlock size={18} />
  ) : (
    <MdOutlineInsertDriveFile size={18} />
  );

export const SupportStatusSelect: React.FC<Props> = ({ value, onChange, isDisabled }) => {
  const theme = useTheme();

  const options = useMemo<SupportSelectOption<TicketStatus>[]>(
    () =>
      ticketStatuses.map((status) => ({
        value: status,
        label: statusLabels[status],
        color: statusColor(status, theme.colors),
        icon: statusIcon(status),
      })),
    [theme.colors],
  );

  return (
    <SupportSelect<TicketStatus>
      value={value}
      options={options}
      onChange={(next) => next && onChange(next)}
      isDisabled={isDisabled}
    />
  );
};
